<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Error</div>

    <div class="modal-body">
      <p>{{ data.message }}</p>
      @if (data.messages) {
        <ul>
          @for (message of data.messages ; track message) {
            <li>
              {{ message }}
            </li>
          }
        </ul>
      }
    </div>
    <div class="modal-footer">
      <span class="modal-footer-left ">
      </span>
      <span class="modal-footer-center ">
        <button type="button" class="btn cl-color-secondary it-ok"
          (click)="dialogRef.close()"
          >
          <span>{{ data.button }}</span>
        </button>
      </span>
      <span class="modal-footer-right "></span>
      </div>
    </div>
  </div>
